// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

var $$Promise = {};

function make(theme) {
  return {
          theme: theme
        };
}

var Parameters = {
  make: make
};

function createTweet(t, id, element, parameters) {
  return t.widgets.createTweet(id, element, parameters);
}

var TwitterApi = {
  Parameters: Parameters,
  createTweet: createTweet
};

var twitterScriptStatus = {
  contents: /* NotAdded */0
};

var callbacks = {
  contents: /* [] */0
};

function addScript(param) {
  var script = document.createElement("script");
  script.setAttribute("src", "//platform.twitter.com/widgets.js");
  script.onload = (function (param) {
      var api = window.twttr;
      if (api !== undefined) {
        twitterScriptStatus.contents = /* Loaded */{
          _0: Caml_option.valFromOption(api)
        };
        Belt_List.forEach(callbacks.contents, (function (callback) {
                return Curry._1(callback, undefined);
              }));
        callbacks.contents = /* [] */0;
      } else {
        console.error("[rescript-react-embed-tweet] unexpected state: twitter script is loaded, but window.twttr is undefined");
      }
      
    });
  document.body.appendChild(script);
  
}

function useTwitterApi(param) {
  var match = React.useState(function () {
        
      });
  var setTwitterApi = match[1];
  React.useEffect((function () {
          var t = twitterScriptStatus.contents;
          if (typeof t === "number") {
            if (t !== 0) {
              callbacks.contents = {
                hd: (function (param) {
                    return Curry._1(setTwitterApi, (function (param) {
                                  return window.twttr;
                                }));
                  }),
                tl: callbacks.contents
              };
            } else {
              twitterScriptStatus.contents = /* Loading */1;
              callbacks.contents = {
                hd: (function (param) {
                    return Curry._1(setTwitterApi, (function (param) {
                                  return window.twttr;
                                }));
                  }),
                tl: callbacks.contents
              };
              addScript(undefined);
            }
          } else {
            var t$1 = t._0;
            Curry._1(setTwitterApi, (function (param) {
                    return Caml_option.some(t$1);
                  }));
          }
          
        }), []);
  return match[0];
}

function TweetEmbed(Props) {
  var className = Props.className;
  var id = Props.id;
  var style = Props.style;
  var themeOpt = Props.theme;
  var onLoad = Props.onLoad;
  var theme = themeOpt !== undefined ? themeOpt : "light";
  var twitterApi = useTwitterApi(undefined);
  var divRef = React.useRef(null);
  React.useEffect((function () {
          var match = divRef.current;
          if (twitterApi !== undefined && !(match == null)) {
            createTweet(Caml_option.valFromOption(twitterApi), id, match, {
                    theme: theme
                  }).then(function (elem) {
                  if (onLoad !== undefined) {
                    if (elem == null) {
                      return Curry._1(onLoad, {
                                  TAG: /* Error */1,
                                  _0: undefined
                                });
                    } else {
                      return Curry._1(onLoad, {
                                  TAG: /* Ok */0,
                                  _0: elem
                                });
                    }
                  }
                  
                });
          }
          var element = divRef.current;
          if (!(element == null)) {
            return (function (param) {
                      element.innerHTML = "";
                      
                    });
          }
          
        }), [
        twitterApi,
        id,
        theme
      ]);
  var tmp = {
    ref: divRef
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  return React.createElement("div", tmp);
}

var make$1 = TweetEmbed;

export {
  $$Promise ,
  TwitterApi ,
  twitterScriptStatus ,
  callbacks ,
  addScript ,
  useTwitterApi ,
  make$1 as make,
  
}
/* react Not a pure module */
